import { jsx as _jsx } from "react/jsx-runtime";
import { Fulfillment as PuiFulfillment } from "@ploy-ui/fulfillment";
import FulfillmentAPI from "@ploy-lib/fulfillment-api";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: theme.spacing(8),
        padding: theme.spacing(4)
    }
}));
export const Fulfillment = ({ dtResult, token = "", endpoint, internalUser }) => {
    const classes = useStyles();
    return (_jsx("div", { className: classes.root, children: _jsx(FulfillmentAPI, { token: token, endpoint: endpoint, children: api => _jsx(PuiFulfillment, { ...api, internalUser: internalUser }) }) }));
};
export default Fulfillment;
//# sourceMappingURL=Fulfillment.js.map